import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Menu = () => {
  const location = useLocation(); // To get the current route/path
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null); // Set initial state to null

  const handleOptionSelect = (option) => {
    console.log(option, "option clicked"); // Log the option clicked
    setSelectedOption(option); // Update the selected option
    setIsOpen(false); // Close dropdown after selecting an option
  };

  useEffect(() => {
    // Automatically update the selected option based on the route
    if (location.pathname === "/contest") {
      setSelectedOption("All Leagues");
    } else if (location.pathname === "/contest/my-games") {
      const viewMode = location.state?.viewMode || "All Leagues"; // Default to "All Games" if viewMode is not set
      setSelectedOption(viewMode === "creator" ? "My Leagues" : "I am a Member");
    }
    else if (location.pathname === "/contest/cash-leagues") {
    setSelectedOption("Cash Leagues");
  }
  }, [location]); // This will trigger every time the location changes


  return (
    <div
      className={`inline-block px-2 mt-4 mb-2 lg:mt-0 w-full ${
        !/^\/contest\/(add-league|game-detail\/\d+)$/.test(location.pathname)
          && "md:px-4 xl:w-2/5 lg:w-1/2 md:w-full"
      }`}
    >
      <div className="flex space-x-2 justify-center lg:justify-end items-start">
        <div className="relative">
          <div className="relative inline-block text-left pb-10">
            <button
              onClick={() => setIsOpen(!isOpen)} // Toggle dropdown
            className={`px-3 md:px-4 inline-flex items-center py-2 m-1 text-sm border-none rounded-full cursor-pointer ${location.pathname === '/contest' || location.pathname.startsWith('/contest/my-games') || location.pathname.startsWith('/contest/cash-leagues')
                ? 'bg-primaryColor text-white font-bold'
                : 'bg-[#f1f5f9] text-black'
              }`}
            >
              {selectedOption || "All Games"} {/* Display the current selected option */}
              <svg
                className="ml-2 -mr-1 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.585l3.71-4.355a.75.75 0 011.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {isOpen && (
              <div className="absolute right-0 z-10 mt-2 md:w-56 w-40 origin-top-right rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                <div className="py-1">
                  <Link
                    to="/contest"
                    state={{ viewMode: "All Leagues" }}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => handleOptionSelect("All Games")}
                  >
                    All Leagues
                  </Link>
                  <Link
                    to="/contest/my-games"
                    state={{ viewMode: "creator" }}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => handleOptionSelect("My Games")}
                  >
                    My Leagues
                  </Link>
                  <Link
                    to="/contest/my-games"
                    state={{ viewMode: "member" }}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => handleOptionSelect("I am a Member")}
                  >
                    I am a Member
                  </Link>
                    <Link
                    to="/contest/cash-leagues"
                    state={{ viewMode: "cash-leagues" }}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => handleOptionSelect("Cash Leagues")}
                  >
                    Cash Leagues
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>

        <Link
          to="/contest/add-league"
          className={`px-3 md:px-4 py-2 m-1 text-sm border-none rounded-full cursor-pointer inline-block ${
            location.pathname === "/contest/add-league"
              ? "bg-primaryColor text-white font-bold"
              : "bg-[#f1f5f9] text-black"
          }`}
        >
          Create League
        </Link>
      </div>
    </div>
  );
};

export default Menu;
